import { CompanyName, CustomerNumber, Siren } from "./SigninFormFields";
import {
  companyNameValidation,
  customerNumberValidation,
  sirenValidation,
} from "./SignInFormValidation";

export const fleetValidationSchema = () =>
  customerNumberValidation()
    .concat(companyNameValidation())
    .concat(sirenValidation());

export const FleetFieldset = () => (
  <>
    <CustomerNumber />
    <CompanyName />
    <Siren />
  </>
);
